var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home-container"
  }, [_vm._m(0), _c('section', {
    staticClass: "services-section"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "menu-cards"
  }, [_c('div', {
    staticClass: "menu-card",
    on: {
      "click": function ($event) {
        return _vm.handleClick('experiment');
      }
    }
  }, [_c('div', {
    staticClass: "card-icon experiment"
  }), _vm._m(1), _vm._m(2)]), _c('div', {
    staticClass: "menu-card",
    on: {
      "click": function ($event) {
        return _vm.handleClick('develope');
      }
    }
  }, [_c('div', {
    staticClass: "card-icon calculation"
  }), _vm._m(3), _vm._m(4)]), _c('div', {
    staticClass: "menu-card",
    on: {
      "click": function ($event) {
        return _vm.handleClick('visualization');
      }
    }
  }, [_c('div', {
    staticClass: "card-icon visualization"
  }), _vm._m(5), _vm._m(6)]), _c('div', {
    staticClass: "menu-card",
    on: {
      "click": function ($event) {
        return _vm.handleClick('matdb');
      }
    }
  }, [_c('div', {
    staticClass: "card-icon ai"
  }), _vm._m(7), _vm._m(8)]), _c('div', {
    staticClass: "menu-card",
    on: {
      "click": function ($event) {
        return _vm.handleClick('literature');
      }
    }
  }, [_c('div', {
    staticClass: "card-icon literature"
  }), _vm._m(9), _vm._m(10)])])])]), _vm._m(11)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "hero-section"
  }, [_c('div', {
    staticClass: "hero-content"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "hero-logo",
    attrs: {
      "src": require("@/assets/platform/m3d-icon.svg"),
      "alt": "M3D HUB"
    }
  })]), _c('h1', {
    staticClass: "hero-title"
  }, [_vm._v("M3D Semiconductor Hub")]), _c('p', {
    staticClass: "hero-subtitle"
  }, [_vm._v("Monolithic 3D Integration(M3D) 반도체 소재·공정 데이터 허브에 오신 것을 환영합니다."), _c('br'), _vm._v("혁신적인 반도체 소재 연구를 위한 데이터 통합 솔루션을 경험해보세요.")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "menu-title"
  }, [_vm._v("실험입력")]), _c('p', {
    staticClass: "menu-description"
  }, [_vm._v("실험 데이터를 체계적으로 관리하고"), _c('br'), _vm._v("신규 내용을 입력해보세요.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-footer"
  }, [_c('i', {
    staticClass: "arrow-icon"
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "menu-title"
  }, [_vm._v("계산입력")]), _c('p', {
    staticClass: "menu-description"
  }, [_vm._v("고도화된 계산 알고리즘을 통한"), _c('br'), _vm._v("데이터 분석을 진행해보세요.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-footer"
  }, [_c('i', {
    staticClass: "arrow-icon"
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "menu-title"
  }, [_vm._v("시각화")]), _c('p', {
    staticClass: "menu-description"
  }, [_vm._v("실험·계산 데이터의 연관관계와"), _c('br'), _vm._v("지식그래프를 탐색해 보세요.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-footer"
  }, [_c('i', {
    staticClass: "arrow-icon"
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "menu-title"
  }, [_vm._v("문헌·계산과학 데이터 검색")]), _c('p', {
    staticClass: "menu-description"
  }, [_vm._v("반도체 소재의 문헌 및 계산과학 데이터를"), _c('br'), _vm._v("탐색·스크리닝하고 Mobility를 예측해 보세요.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-footer"
  }, [_c('i', {
    staticClass: "arrow-icon"
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "menu-title"
  }, [_vm._v("문헌 수집")]), _c('p', {
    staticClass: "menu-description"
  }, [_vm._v("논문 DOI 등록·추출 데이터 업로드,"), _c('br'), _vm._v("수집된 문헌 데이터를 검색·시각화해 보세요.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-footer"
  }, [_c('i', {
    staticClass: "arrow-icon"
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "partners-section"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('h4', {
    staticClass: "partner-heading"
  }, [_vm._v("PARTNERS")]), _c('div', {
    staticClass: "partner-list"
  }, [_c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.etri.re.kr/",
      "target": "_blank",
      "data-tooltip": "한국전자통신연구원"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/ETRI.png"),
      "alt": "ETRI"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.krict.re.kr/",
      "target": "_blank",
      "data-tooltip": "한국화학연구원"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/KRICT.png"),
      "alt": "KRICT"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.kist.re.kr/",
      "target": "_blank",
      "data-tooltip": "한국과학기술연구원"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/KIST.png"),
      "alt": "KIST"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.dongguk.edu/",
      "target": "_blank",
      "data-tooltip": "동국대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/DGU.png"),
      "alt": "DGU"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.hnu.kr/",
      "target": "_blank",
      "data-tooltip": "한남대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/HNU.png"),
      "alt": "HNU"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.inu.ac.kr/",
      "target": "_blank",
      "data-tooltip": "인천대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/INU.png"),
      "alt": "INU"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.dankook.ac.kr/",
      "target": "_blank",
      "data-tooltip": "단국대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/DKU.png"),
      "alt": "DKU"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.khu.ac.kr/",
      "target": "_blank",
      "data-tooltip": "경희대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/KHU.png"),
      "alt": "KHU"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.skku.edu/",
      "target": "_blank",
      "data-tooltip": "성균관대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/SKKU.png"),
      "alt": "SKKU"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.postech.ac.kr/",
      "target": "_blank",
      "data-tooltip": "포항공과대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/POSTECH.png"),
      "alt": "POSTECH"
    }
  })]), _c('a', {
    staticClass: "partner-link",
    attrs: {
      "href": "https://www.pusan.ac.kr/",
      "target": "_blank",
      "data-tooltip": "부산대학교"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": require("@/style/new/images/partners/PNU.png"),
      "alt": "PNU"
    }
  })])])])]);

}]

export { render, staticRenderFns }